import { render, staticRenderFns } from "./svgLinkedinCo.vue?vue&type=template&id=13c1633c&scoped=true"
import script from "./svgLinkedinCo.vue?vue&type=script&lang=js"
export * from "./svgLinkedinCo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1633c",
  null
  
)

export default component.exports